<template>
  <!-- "I'm giving for the first time" on the pledge form, as P1a draws it: the
       youth and couple ticks' tinted row, round tick, bold label, on its own under
       the youth tick for a one-time or a five-month pledge. -->
  <div
    class="rounded-[16px] border border-solid border-campaign-line bg-campaign-divider px-[20px] py-[16px] [--hogc-checkbox-radius:9999px]"
    data-test="bf-first-time"
  >
    <!-- `!h-auto !mb-0`: FormInput.vue's unscoped `label { height: 24px }`, as on the
         form's other ticks. -->
    <DsCheckbox
      :modelValue="modelValue"
      :label="label"
      size="lg"
      class="!h-auto !mb-0"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import { Checkbox as DsCheckbox } from '@team-hogc/hogc-one-design-system';
import { BF_FIRST_TIME_LABEL } from '@/constants/MyGiving/building-fund-pledge';

export default {
  name: 'PledgeFirstTimeTick',

  components: { DsCheckbox },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      label: BF_FIRST_TIME_LABEL,
    };
  },
};
</script>
